"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _BuySellComponent = _interopRequireDefault(require("./BuySellComponent"));
var _orderEntryFormConstants = require("../../../../constants/sendOrder/orderEntryFormConstants");
var _modalActions = require("../../../../redux/actions/modalActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var BuySellComponentForm = (0, _reduxForm.reduxForm)({
  form: 'buySell',
  onSubmit: function onSubmit(payload, dispatch) {
    dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.RETAIL_SUBMIT_ORDER));
  },
  destroyOnUnmount: false
})(_BuySellComponent["default"]);
var mapStateToProps = function mapStateToProps(state) {
  return {
    initialValues: {
      side: _orderEntryFormConstants.buyValue,
      amountRadio: 'custom',
      price: '',
      quantity: '',
      fee: '0',
      orderType: _orderEntryFormConstants.orderTypes.limit.displayName,
      responseMessage: ''
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(BuySellComponentForm);